import { render, staticRenderFns } from "./FaturaDespesaFilterBar.vue?vue&type=template&id=4e24108e"
import script from "./FaturaDespesaFilterBar.vue?vue&type=script&lang=js"
export * from "./FaturaDespesaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports